import { DotsVerticalSolid, IconButton, IconButtonProps, MenuButton } from '@bonusly/design-system';

export type RowActionsMenuButtonProps = Omit<IconButtonProps, 'aria-label' | 'children' | 'icon'> & {
	'aria-label': string;
};

export const RowActionsMenuButton = ({ 'aria-label': ariaLabel, variant = 'ghost', size = 'sm', ...rest }: RowActionsMenuButtonProps) => (
	<MenuButton as={IconButton} aria-label={ariaLabel} icon={<DotsVerticalSolid size="xs" />} variant={variant} size={size} {...rest} />
);
